import React, { FC, memo } from 'react';
import { TableCell } from '@material-ui/core';
import classNames from 'classnames';

import { Column, Datum } from './types';
import useStyles from './styles';

interface Props {
  datum: Datum;
  index: number;
  columnLength: number;
  column: Column;
  isHighlighted: boolean;
}

const TableBodyCellMemoized: FC<Props> = memo(function TableBodyCell(props) {
  const { column, columnLength, datum, index, isHighlighted } = props;
  const classes = useStyles();

  const { cellProps, cellRenderer, width } = column;

  const isPenultimate = index === columnLength - 2;
  const isLast = index === columnLength - 1;

  const penultimateClasses = classNames(classes.tableCell, classes.penultimateCell);
  const lastClasses = classNames(classes.tableCell, {
    [classes.hide]: isLast && isHighlighted,
  });

  if (isPenultimate) {
    return (
      <TableCell className={penultimateClasses} {...cellProps}>
        {cellRenderer(datum)}
      </TableCell>
    );
  }

  return (
    <TableCell className={lastClasses} style={{ maxWidth: width, flexBasis: width }} {...cellProps}>
      {cellRenderer(datum)}
    </TableCell>
  );
});

export default TableBodyCellMemoized;
